import { defineStore, getActivePinia } from 'pinia'

import type { GaApp } from '~/modules/app'

import { state } from './state'

export const menuStore = (gaApp: GaApp) => {
  const init = defineStore('menu', {
    state,
  })

  return init(getActivePinia())
}
